import { render, staticRenderFns } from "./PermissionCardPopover.vue?vue&type=template&id=321d50bc"
import script from "./PermissionCardPopover.vue?vue&type=script&lang=js"
export * from "./PermissionCardPopover.vue?vue&type=script&lang=js"
import style0 from "./PermissionCardPopover.vue?vue&type=style&index=0&id=321d50bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports